// Version imports
import v100 from 'src/components/forms/schemas/eventResult/caseManagerNote/1.0.0';

export default {
  latest: v100,
  // All Versions
  '1.0.0': v100,
};
